import { TDescriptionValue } from 'shared/types/typographyComponents';
import { Block } from '../Block';
import { CustomList } from '../CustomList';
import { Description } from '../Description';
import { SubTitle } from '../SubTitle';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';
import { DetailsBtnLink } from '../DetailsBtnLink';

interface ITextInfoWithImageProps {
  list?: TDescriptionValue[][];
  image: string;
  title?: string;
  listTitle?: string;
  description?: TDescriptionValue[][];
  descriptionAfterList?: TDescriptionValue[][];
  btnLink?: string;
}

export const TextInfoWithImage: React.FC<ITextInfoWithImageProps> = ({
  list,
  image,
  title,
  listTitle,
  description,
  descriptionAfterList,
  btnLink,
}) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['wrapper']}>
        <div className={styles['textblock']}>
          <Block>
            {title && <SubTitle text={title} />}
            {description && description.map((descr, key) => <Description text={descr} key={key} />)}
            {listTitle && <SubTitle text={listTitle} />}
            {list && <CustomList items={list} />}
            {descriptionAfterList && descriptionAfterList.map((descr, key) => <Description text={descr} key={key} />)}
          </Block>
        </div>
        <div className={clsx(styles['image'], styles[image])} />
      </div>
      {btnLink && <DetailsBtnLink link={btnLink} />}
    </div>
  );
};
